import { render } from "./SocialsSection.vue?vue&type=template&id=da73f3ca"
import script from "./SocialsSection.vue?vue&type=script&lang=js"
export * from "./SocialsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__